import { NodeModel } from '@minoru/react-dnd-treeview';
import {
    InterruptionModel,
    InterruptionsListModel,
} from '../../models/interruptions/interruptionList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    interruptionList: InterruptionsListModel;
    getInterruptionsList: (
        startDate: string,
        endDate: string,
        employeeID: string | number,
        interruptionList: InterruptionsListModel
    ) => InterruptionModel[];
    openUpdateAndDeleteInterruptionsModal: (
        startDate: string | number,
        endDate: string | number,
        employee: NodeModel[],
        interruption: InterruptionModel[][]
    ) => void;
};

export const controllerModifyInterruptionModal = ({
    grid,
    treeEmployees,
    startDate,
    interruptionList,
    endDate,
    getInterruptionsList,
    openUpdateAndDeleteInterruptionsModal,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let interruptions: InterruptionModel[][] = [];

    for (let emp = 0; emp < selectedEmployees?.length; emp++) {
        let interruption = getInterruptionsList(
            initDate,
            lastDate,
            selectedEmployees[emp].id,
            interruptionList
        );

        if (interruption?.length > 0) {
            let newInterruptioks: InterruptionModel[] = [];

            interruption.forEach((interr) => {
                if (!interr.isAdditionalHour) {
                    newInterruptioks.push(interr);
                }
            });
            if (newInterruptioks?.length > 0) {
                interruptions.push(newInterruptioks);
            }
        }
    }

    if (
        initDate &&
        lastDate &&
        selectedEmployees?.length > 0 &&
        interruptions[0]?.length > 0
    ) {
        openUpdateAndDeleteInterruptionsModal(
            initDate,
            lastDate,
            selectedEmployees,
            interruptions
        );
    }
};
